export default "__VITE_ASSET__CEWhSkGQ__"